export function getDateInputValueInTimeZone(date = new Date(), timeZone) {
    try {
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });

        const parts = formatter.formatToParts(date);
        const year = parts.find((p) => p.type === "year")?.value;
        const month = parts.find((p) => p.type === "month")?.value;
        const day = parts.find((p) => p.type === "day")?.value;

        if (year && month && day) {
            return `${year}-${month}-${day}`;
        }
    } catch (err) {
        // Fallback below handles unsupported/invalid time zones.
    }

    // Browser-local fallback in YYYY-MM-DD format.
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localDate.toISOString().slice(0, 10);
}
